import Utils from '@/ecm/common/Utils';
export default class PluginRight {
    constructor (dto) {
        this.uuid = Utils.object.getUUID();
        this.roleTypeIDs = [];
        this.conditionStr = '';
        this.displayConditionStr = '';

        if (dto) {
            this.roleTypeIDs = dto.RoleTypeIDs.map(x => x + '');
            this.conditionStr = dto.ConditionStr;
            this.displayConditionStr = dto.DisplayConditionStr;
        }
    }

    toDto () {
        return {
            RoleTypeIDs: this.roleTypeIDs.map(x => parseInt(x)),
            ConditionStr: this.conditionStr,
        };
    }
}
